import { LoadingOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { Rule } from "antd/es/form";
import { FC, ReactNode } from "react";
import G_Div from "../Containers/G_Div";

interface Props {
  children: ReactNode;
  prefixIcon: ReactNode;
  initialValue: any;
  rules: Rule[];
  name: string;
  help: any;
  height?: string;
  isLoading?: boolean;
}

export const InputWrapper: FC<Props> = ({
  children,
  prefixIcon,
  initialValue,
  rules,
  name,
  help,
  height,
  isLoading
}) => (
  <G_Div
    className={`flex ${height} ${
      prefixIcon ? "px-4" : "px-1"
    } py-0 items-center gap-2 border border-ox-toggle-grey rounded-md w-full overflow-hidden`}
  >
    {isLoading ? <LoadingOutlined /> : prefixIcon}
    <Form.Item
      initialValue={initialValue}
      className="flex-1"
      rules={rules}
      name={name}
      help={help}
    >
      {children}
    </Form.Item>
  </G_Div>
);
